(function(){
  /* 1) SureBright: never start with a paid plan selected. Shopper must choose it. */
  var touched=false;
  document.addEventListener('pointerdown',function(e){if(e.target.closest&&e.target.closest('.offeringCard,.warranty-card,[class*=offering]'))touched=true;},true);
  document.addEventListener('keydown',function(e){if(e.target.closest&&e.target.closest('.offeringCard,.warranty-card,[class*=offering]'))touched=true;},true);
  var busy=false;
  var sfLive1=document.getElementsByClassName('selected-offer'),sfLive2=document.getElementsByClassName('selected-feature-offer');
  function clearPreselect(){
    if(touched||busy)return;
    if(!sfLive1.length&&!sfLive2.length)return; /* SF speed v2: cheap live-collection check before the full query */
    var sel=document.querySelector('.offeringCard.selected-offer,.warranty-card.selected-offer,.featured-offeringCard.selected-feature-offer');
    if(!sel)return;
    busy=true;
    try{sel.click();}catch(e){}
    setTimeout(function(){
      document.querySelectorAll('.selected-offer,.selected-feature-offer').forEach(function(x){if(x.closest('.offeringCard,.warranty-card,.featured-offeringCard')||x.matches('.offeringCard,.warranty-card,.featured-offeringCard'))x.classList.remove('selected-offer','selected-feature-offer');});
      if(window.sbPolicySelectionDB){for(var k in window.sbPolicySelectionDB)window.sbPolicySelectionDB[k]=null;}
      document.documentElement.setAttribute('data-sf-sb-cleared','1');
      busy=false;
    },60);
  }
  if('MutationObserver' in window){
    var sfq1=0;new MutationObserver(function(){if(sfq1)return;sfq1=1;requestAnimationFrame(function(){sfq1=0;clearPreselect();});}).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
  }
  /* 2) Mobile: long description becomes collapsible sections (grouped by h2/h3) */
  var mq=window.matchMedia('(max-width:749px)');
  function headOf(el){
    if(el.matches('h2,h3'))return el;
    if(el.matches('section,div')){var f=el.firstElementChild;var k=0;while(f&&k<2){if(f.matches('h2,h3'))return f;if(f.matches('p.sf-kicker,.sf-kicker'))f=f.nextElementSibling;else break;k++;}}
    return null;
  }
  function pickContainer(rte){
    var best=null,bestN=0;
    var walk=function(el,depth){if(depth>5)return;var n=0;for(var c=el.firstElementChild;c;c=c.nextElementSibling){if(headOf(c))n++;}
      if(n>bestN){best=el;bestN=n;}for(var d=el.firstElementChild;d;d=d.nextElementSibling){if(!d.matches('table,ul,ol,p,details'))walk(d,depth+1);}};
    walk(rte,0);return bestN>=3?best:null;
  }
  function accordion(){
    if(!mq.matches)return;
    document.querySelectorAll('.hdt-product-tab .hdt-rte').forEach(function(rte){
      if(rte.dataset.sfAcc)return;rte.dataset.sfAcc='1';
      var box=pickContainer(rte);if(!box)return;
      var kids=[].slice.call(box.children),cur=null,groups=0;
      kids.forEach(function(c){
        var h=headOf(c);
        if(h){groups++;
          if(groups===1){cur=null;return;}
          var t=(h.textContent||'').replace(/\s+/g,' ').trim().slice(0,90);
          var d=document.createElement('details');d.className='sf-m-acc';
          var sm=document.createElement('summary');sm.textContent=t;
          var b=document.createElement('div');b.className='sf-m-acc__body';
          d.appendChild(sm);d.appendChild(b);box.insertBefore(d,c);
          if(h===c){c.remove();}else{h.style.display='none';b.appendChild(c);}
          cur=b;return;
        }
        if(cur)cur.appendChild(c);
      });
    });
  }
  /* 3) Hide Judge.me review widgets that have no reviews yet */
  function hideEmptyReviews(){
    document.querySelectorAll('.jdgm-widget,.jdgm-preview-badge').forEach(function(w){
      if(w.__sfRevDone)return; /* SF speed v2: decided once a review count is known */
      var z=w.querySelector('[data-number-of-reviews]');var n=z?parseInt(z.getAttribute('data-number-of-reviews'),10):NaN;
      if(!isNaN(n))w.__sfRevDone=true;
      if(n===0||(isNaN(n)&&/be the first to write a review|no reviews yet/i.test(w.textContent))){var box=w.closest('.shopify-app-block')||w;box.style.display='none';}
    });
  }
  hideEmptyReviews();
  if('MutationObserver' in window){var sfq2=0;var rm=new MutationObserver(function(){if(sfq2)return;sfq2=1;requestAnimationFrame(function(){sfq2=0;hideEmptyReviews();});});rm.observe(document.documentElement,{subtree:true,childList:true});setTimeout(function(){rm.disconnect();},15000);}
  if(document.readyState==='complete')accordion();else window.addEventListener('load',accordion);
})();
